import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


// Custom Dropdown Component
const Index = ({ estates, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  localStorage.setItem('estateID', estates.id);
  localStorage.setItem('estateName', estates.name);

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Function to close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(`#dropdown-${estates.id}`)) {
        setIsOpen(false);
      }
    };

    // Add event listener to close dropdown on outside click
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [estates.id]);


  return (
    <div className="dropdown" id={`dropdown-${estates.id}`} style={{ position: 'relative' }}>
      <button
        className="btn btn-outline-primary"
        type="button"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : 'false'}
      >
        Estate Dashboard
      </button>
      <div className={`dropdown-menu ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', position: 'absolute', top: '100%', zIndex: 1 }}>
        <Link to="/rotators">
          <button className="dropdown-item" >
            Emergency Rotator
          </button>
        </Link>
        <Link to="/estate-members">
          <button className="dropdown-item" >
            Members
          </button>
        </Link>
        <Link to="/estate-noticeboard">
          <button className="dropdown-item" >
            Noticeboard
          </button>
        </Link>
        <Link to="/estate-pay">
          <button className="dropdown-item" >
            Estate-Pay
          </button>
        </Link>
        <Link to="/estate-boda-stage">
          <button className="dropdown-item" >
            Boda Stage
          </button>
        </Link>
        <Link to="/service-provider/category">
          <button className="dropdown-item" >
            Service Provider
          </button>
        </Link>
        <Link to="/estates/activities">
          <button className="dropdown-item" >
            Activities
          </button>
        </Link>

      </div>
    </div>
  );
};

export default Index;
